import { post, get } from '@api/request';

export async function createJob(
  { importService },
  authenticationToken,
  { payload },
) {
  const url = `${importService}/import/masscassvalidation`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function validateQuery(
  { importService },
  authenticationToken,
  { payload },
) {
  const url = `${importService}/import/masscassvalidation/validatequery`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchJobs(
  { importService },
  authenticationToken,
  { payload },
) {
  const url = `${importService}/import/masscassvalidation?page=${payload.page}&pageSize=${payload.pageSize}`;
  const { body } = await get(authenticationToken, url, payload);
  return body;
}

export async function fetchJobDetails(
  { importService },
  authenticationToken,
  { payload },
) {
  const url = `${importService}/import/masscassvalidation/details/${payload.runID}?displayType=${payload.displayType}&page=${payload.page}&pageSize=${payload.pageSize}`;
  const { body } = await get(authenticationToken, url, payload);
  return body;
}

export async function fetchJobDetail(
  { importService },
  authenticationToken,
  { payload },
) {
  const url = `${importService}/import/masscassvalidation/detail/${payload.runID}`;
  const { body } = await get(authenticationToken, url, payload);
  return body;
}

export async function convertAddresses(
  { importService },
  authenticationToken,
  { payload },
) {
  const url = `${importService}/import/masscassvalidation/convert/${payload.runID}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}
